class UkrainePopup extends HTMLElement {
    constructor() {
      super();
  
      this.modal = document.querySelector("#popup-ukraine");
      this.triggerByCountry = this.modal.getAttribute("data-country");
      this.ukraineLink = this.modal.getAttribute("data-ukraine-link");
      this.btnYes = this.querySelector(".btn-yes");
      this.btnNo = this.querySelector(".btn-no");
      this.btnClose = this.querySelector(".close");
  
      this.btnYes.addEventListener("click", this.onYes.bind(this));
      this.btnNo.addEventListener("click", this.onNo.bind(this));
      this.btnClose.addEventListener("click", this.closePopup.bind(this));
  
      if (
        !localStorage.getItem("confirmation-popup-response") &&
        localStorage.getItem("confirmation-popup-response") != "no"
      ) {
        this.checkCountry();
      }
    }
  
    checkCountry() {
      fetch("https://pro.ip-api.com/json/?key=RHxbtSkBVb67k14&fields=country")
        .then((response) => response.text())
        .then((text) => {
          const country = JSON.parse(text).country;
  
          /**
           * Show modal once the country from IP address is matched with the data-country attribute
           */
          if (country === this.triggerByCountry) {
            this.showPopup();
          }
        })
        .catch((error) => console.error(error));
    }
  
    showPopup() {
      if (this.modal) {
        this.modal.classList.add("show");
        document.querySelector("body").style.overflow = "hidden";
      }
    }
  
    closePopup() {
      if (this.modal) {
        this.modal.classList.remove("show");
        document.querySelector("body").style.overflow = "auto";
      }
    }
  
    onYes(event) {
      event.preventDefault();
      window.location.assign(this.ukraineLink);
    }
  
    onNo(event) {
      localStorage.setItem("confirmation-popup-response", "no");
      event.preventDefault();
      this.closePopup();
    }
  }
  
  customElements.define("ukraine-popup", UkrainePopup);
  